<template>
<!-- 新增账号 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="params"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item :label="$t('pages.system.text66')" prop="username">
          <el-input
            v-model="params.username"
            autocomplete="new-password"
            :disabled="this.accountManagementAddState == 2"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text94')" prop="password">
          <el-input
            v-model="params.password"
            show-password
            autocomplete="new-password"
            :disabled="accountManagementAddState == 2"
          >
            <template slot="append"
              ><el-button
                :disabled="accountManagementAddState == 2"
                @click="randomString"
                >{{ $t("button.autoGeneration") }}</el-button
              ></template
            >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text69')" prop="departmentId">
          <el-select
            :disabled="accountManagementAddState == 2"
            v-model="params.departmentId"
            :placeholder="$t('button.pleaseSelect')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text70')" prop="roleIds">
          <el-checkbox-group
            :disabled="accountManagementAddState == 2"
            v-model="params.roleIds"
          >
            <el-checkbox
              :label="item.value"
              v-for="(item, index) in roleList"
              :key="index"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text68')" prop="realName">
          <el-input
            v-model="params.realName"
            :disabled="accountManagementAddState == 2"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text95')" prop="email">
          <el-input
            v-model="params.email"
            :disabled="accountManagementAddState == 2"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{
        this.accountManagementAddState == 2
          ? $t("button.close")
          : $t("button.cancel")
      }}</el-button>
      <el-button
        type="primary"
        v-if="this.accountManagementAddState != 2"
        @click="submit"
        >{{ $t("button.determine") }}</el-button
      >
    </span>
  </el-dialog>
</template>


<script>
import {
  validateUsername,
  validatName,
  validatArrLength,
  validatEmailAddress,
  validatePassword,
} from "../../../../utils/util/test";
import { mapState } from "vuex";
import { randomString } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      title: this.$t("button.add"),
      params: {
        belongCustomerId: "", //客户id
        departmentId: "", //部门id
        email: "", //邮箱
        imageBean: null, //	图片信息
        password: "", //密码
        realName: "", //真实姓名
        roleIds: [], //角色ids
        username: "", //账号名称
      },
      options: [],
      roleList: [],
      rules: {
        email: [{ validator: validatEmailAddress, trigger: "blur" }],
        realName: [{ validator: validatName, trigger: "blur" }],
        roleIds: [{ validator: validatArrLength, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        username: [
          {
            validator: validateUsername,
            trigger: "blur",
          },
          {
            required: true,
            message: this.$t("pages.system.text96"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: this.$t("pages.system.text97"),
            trigger: "blur",
          },
        ],
        departmentId: {
          required: true,
          message: this.$t("pages.system.text98"),
          trigger: "blur",
        },
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.accountManagementAddState == 0) {
          this.title = this.$t("button.add") + this.$t("pages.system.text66");
        }
        if (this.accountManagementAddState == 1) {
          this.title = this.$t("button.edit") + this.$t("pages.system.text66");
        }
        if (this.accountManagementAddState == 2) {
          this.title = this.$t("button.look") + this.$t("pages.system.text66");
        }
        if (this.accountManagementAddState != 0) {
          this.params.belongCustomerId = this.currentAccount.belongCustomerId;
          this.params.departmentId = this.currentAccount.departmentId;
          this.params.email = this.currentAccount.email;
          this.params.imageBean = null;
          this.params.password = this.currentAccount.post;
          this.params.realName = this.currentAccount.realName;
          this.params.id = this.currentAccount.id;
          for (let i in this.currentAccount.roles) {
            this.params.roleIds.push(this.currentAccount.roles[i].id);
          }
          this.params.username = this.currentAccount.username;
        } else {
          this.randomString();
        }
      }
    },
  },
  props: ["dialogVisible", "accountManagementAddState", "currentAccount"],
  mounted() {
    this.departmentManagementListAll();
    this.roleManagementListAll();
  },
  methods: {
    //自动生成密码
    randomString() {
      this.params.password = randomString(6);
    },
    //取消
    handleClose() {
      this.params = {
        belongCustomerId: "", //客户id
        departmentId: "", //部门id
        email: "", //邮箱
        imageBean: null, //	图片信息
        password: "", //密码
        realName: "", //真实姓名
        roleIds: [], //角色ids
        username: "", //账号名称
      };
      this.params.departmentId = "";
      this.params.email = "";
      this.params.imageBean = null;
      this.params.password = "";
      this.params.realName = "";
      this.params.id = "";
      this.params.roleIds = [];
      this.params.username = "";
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //提交
    submit() {
      this.params.belongCustomerId = this.platformData.id;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.accountManagementAddState == 0) {
            this.request.accountManagementAdd(this.params).then(() => {
              this.$message.success(this.$t("pages.system.text99"));
              this.handleClose();
              this.$emit("accountManagementList");
            });
          } else {
            this.request.accountManagementEdit(this.params).then(() => {
              this.$message.success(this.$t("pages.system.text100"));
              this.handleClose();
              this.$emit("accountManagementList");
            });
          }
        }
      });
    },
    //部门管理-查询所有部门
    departmentManagementListAll() {
      this.request.departmentManagementListAll().then((res) => {
        let arr = [];
        for (let i in res.data.departmentList) {
          arr.push({
            value: res.data.departmentList[i].id,
            label: res.data.departmentList[i].departmentName,
          });
        }
        this.options = arr;
      });
    },
    //查询所有角色
    roleManagementListAll() {
      this.request.roleManagementListAll().then((res) => {
        let arr = [];
        for (let i in res.data) {
          arr.push({
            value: res.data[i].id,
            label: res.data[i].roleName,
          });
        }
        this.roleList = arr;
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
.auto-button {
  cursor: pointer;
}
</style>